import Stack from '@mui/material/Stack'
import { Text } from '@mxenabled/mxui'

interface HeaderComponentProps {
  headerText?: string
}

export const HeaderComponent = ({ headerText }: HeaderComponentProps) => {
  return (
    <Stack
      sx={{
        bgcolor: 'background.default',
        borderBottomColor: 'divider',
        borderBottomStyle: 'solid',
        borderBottomWidth: '1px',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        px: 16,
        py: 8,
        width: '100%',
      }}
    >
      <Text sx={{ color: 'text.secondary' }} variant="caption">
        {headerText}
      </Text>
    </Stack>
  )
}
